import React, { useRef } from "react"
import { useHubspotForm } from "../hooks/useHubspotForm"
import { Box, Center, Group, Loader, Text, ThemeIcon, Title } from "@mantine/core"
import { EnvelopeIcon } from "@phosphor-icons/react"
import { HUBSPOT_INQUIRY_FORM_ID, HUBSPOT_PORTAL_ID, HUBSPOT_REGION } from "../utils/hubspot"

const InquiryContainer: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { status } = useHubspotForm(containerRef)

  return (
    <Box>
      <Group gap={12} mb={16}>
        <ThemeIcon variant="transparent" color="#CA8E00">
          <EnvelopeIcon weight="fill" size={36} />
        </ThemeIcon>
        <Title size={24} fw={600} c="#000000CC">お問い合わせ</Title>
      </Group>

      <Box bg="#00000008" p={16} bdrs={8}>
        {status === 'loading' && (
          <Center mih={400}>
            <Loader />
          </Center>
        )}

        {status === 'error' && (
          <Text fz={13} c="dimmed">フォームを読み込めませんでした</Text>
        )}

        <div
          ref={containerRef}
          className="hs-form-frame"
          data-region={HUBSPOT_REGION}
          data-form-id={HUBSPOT_INQUIRY_FORM_ID}
          data-portal-id={HUBSPOT_PORTAL_ID}
        />
      </Box>
    </Box>
  )
}

export default InquiryContainer
